import { render } from "./ProjectListWidget.vue?vue&type=template&id=d2acc1ec&ts=true"
import script from "./ProjectListWidget.ts?vue&type=script&lang=ts&external"
export * from "./ProjectListWidget.ts?vue&type=script&lang=ts&external"

import "./ProjectListWidget.vue?vue&type=style&index=0&id=d2acc1ec&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__